import types from './types'

export { default as actions } from './actions'

export const INITIAL_STATE = []

const collegeCompare = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case types.UPDATE_COLLEGE_COMPARE:
      return action.payload
    case types.CLEAR_COLLEGE_COMPARE:
      return INITIAL_STATE
    default:
      return state
  }
}

export default collegeCompare
